import { useEffect, useState } from 'react';
export function useDebounced(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => clearTimeout(timeout);
    }, [value, delay]);
    return debouncedValue;
}
export function useDebouncedCallback(callback, delay) {
    const [debouncedCallback] = useState(() => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                callback(...args);
            }, delay);
        };
    });
    return debouncedCallback;
}
//# sourceMappingURL=useDebounced.js.map